export const AUTH_REPO = 'AUTH_REPO';
export const AUTH_SERVICE = 'AUTH_SERVICE';
